import React from 'react'
import Redirect from '#src/components/Redirect'
import cookies from 'js-cookie'
import config from '#src/config'
import TeaserChatWidgetWithExpert from '#src/components/EngagementChannels/TeaserChatWidgetWithExpert'
import { EngagementChannelCategoryFragment } from '#src/generated/graphql'
import { withAnalytics, WithAnalyticsProps } from '#src/containers/Analytics'
import { generateCreateUrlFromCategory } from '#src/services/path'
import Takeover from './Takeover'
import { ExperimentPlacements } from '../EngagementChannelHandler'
import { FullPageTakoverSchema } from './schema'

interface FullPageTakeoverProps {
  category: EngagementChannelCategoryFragment
  placement: ExperimentPlacements
}

interface FullPageTakeoverState {
  redirect?: string
  hasModalBeenViewed: boolean
  hasModalBeenDismissed: boolean
}

export interface ContentfulResponse {
  content: FullPageTakoverSchema
  loading: boolean
}

class FullPageTakeover extends React.Component<
  FullPageTakeoverProps & WithAnalyticsProps,
  FullPageTakeoverState
> {
  constructor(props: FullPageTakeoverProps & WithAnalyticsProps) {
    super(props)

    this.state = {
      /**
       * This is default to 'seen' since we'd rather it show up late after the component
       * mounts than have it show on load and hide.
       */
      hasModalBeenViewed: true,
      hasModalBeenDismissed: false
    }

    this.handleDismissModal = this.handleDismissModal.bind(this)
    this.handleSubmitModal = this.handleSubmitModal.bind(this)
  }

  public componentDidMount() {
    this.setState({
      hasModalBeenViewed: cookies.get('deal_full_page_takeover_viewed') !== undefined
    })
  }

  public handleSetCookie() {
    cookies.set('deal_full_page_takeover_viewed', 'true', {
      // Expires in 24 hours
      expires: 1,
      domain: config.get('consumer.clientSideCookieDomain')
    })
  }

  public handleSubmitModal(categorySlug: string | null, contentfulVariation: string) {
    if (this.props.analytics) {
      this.props.analytics.events.engagementChannelSubmitted({
        engagement_channel: 'full-page-takeover',
        variation: contentfulVariation,
        category: this.props.category.slug
      })
    }

    this.setState(
      {
        redirect: generateCreateUrlFromCategory({
          maybeCategorySlug: categorySlug,
          sourceKey: 'full-page-takeover-engagement-channel',
          pathIntent: 'request'
        })
      },
      this.handleSetCookie
    )
  }

  public handleDismissModal(contentfulVariation: string) {
    if (this.props.analytics) {
      this.props.analytics.events.engagementChannelDismissed({
        engagement_channel: 'full-page-takeover',
        variation: contentfulVariation,
        category: this.props.category.slug
      })
    }

    this.setState(
      {
        hasModalBeenViewed: true
      },
      this.handleSetCookie
    )

    // Delay chat teaser 3 seconds
    setTimeout(() => {
      this.setState({ hasModalBeenDismissed: true }), 3000
    })
  }

  public render() {
    const { category, placement } = this.props

    if (this.state.hasModalBeenDismissed) {
      return <TeaserChatWidgetWithExpert categoryId={category.id} />
    }

    if (this.state.hasModalBeenViewed) {
      return null
    }

    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />
    }

    return (
      <Takeover
        placement={placement}
        category={category}
        onSetCookie={this.handleSetCookie}
        onDismissModal={this.handleDismissModal}
        onSubmitModal={this.handleSubmitModal}
      />
    )
  }
}

export default withAnalytics(FullPageTakeover)
